module.exports = __webpack_public_path__ + "img/ep8-6.455f305c.png";